import { render, staticRenderFns } from "./BarberExpectationsDataSheet.vue?vue&type=template&id=9f8e5d38"
import script from "./BarberExpectationsDataSheet.vue?vue&type=script&lang=js"
export * from "./BarberExpectationsDataSheet.vue?vue&type=script&lang=js"
import style0 from "./BarberExpectationsDataSheet.vue?vue&type=style&index=0&id=9f8e5d38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports